// src/lib/user/purgeDeprecatedLocalStorage.js
// Removes localStorage keys that have been migrated to Supabase user_preferences.
// Safe to call on every app load — idempotent.
// Only removes keys that are now DB-primary; keys that are still used as
// offline fallbacks (e.g. portfolio_os_settings, wm_active_layers) are
// kept so the app continues to work without a DB connection.

const DEPRECATED_KEYS = [
  // "welcome_guide_done" was set directly in WelcomeGuide.jsx.
  // Now handled exclusively via settings.welcomeGuideDone (DB primary).
  "welcome_guide_done",
];

export function purgeDeprecatedLocalStorage() {
  for (const key of DEPRECATED_KEYS) {
    try { localStorage.removeItem(key); } catch {}
  }
}
